import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import night_mode_gen_2 from '@devices/settings/device_settings/night_mode_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_pro from '@devices/settings/device_settings/networks_gen_2_pro.js';
import virtual_components_pro_devices from '@devices/settings/device_settings/virtual_components_pro_devices.js';
import safety_gen_2_under_voltage from '@devices/settings/device_settings/safety_gen_2_under_voltage.js';
import app_setting_plus_rgbw_gen_2 from '@devices/settings/common_settings/app_setting_plus_rgbw_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import pro_dimmer_settings_gen_2 from '@devices/settings/device_settings/pro_dimmer_settings_gen_2.js';
import bluetooth_bt_home_control_gen_2 from '@devices/settings/device_settings/bluetooth_bt_home_control_gen_2';
import addon_sensors, { addon_pro_devices } from '@devices/settings/device_settings/addon_sensors';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'ShellyProDM1PM',
	friendly_name: 'Pro Dimmer 1 PM',
	family: 'light',
	isPM: true,
	addons: addon_pro_devices,
	modes: {
		light: {
			availableViews: ['basic'],
			channels: 1,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'forgotten_lights',
				'overvoltage',
				'overtemperature',
			],
			color_temp: false,
			slider: 'brightness',
			brightness: 0,
			effects: false,
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				addon_sensors,
				night_mode_gen_2,
				scripts_gen_2,
				networks_gen_2_pro,
				bluetooth_bt_home_control_gen_2,
				virtual_components_pro_devices,
				safety_gen_2_under_voltage,
				app_setting_plus_rgbw_gen_2,
				share,
				pro_dimmer_settings_gen_2,
			],
		},
	},
};
